import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { SectionHeading } from './SectionHeading';
import { CtaButton } from './ui/CtaButton';
import { tomos } from '../data/content';
export function TomosSection() {
  return <section aria-labelledby="tomos" className="border-y-2 border-volt/25 bg-carbon" data-id="element-232" data-mp="1p5wkr0d3kheu">
      <div className="mx-auto max-w-page px-3 py-8 sm:px-6 sm:py-10" data-id="element-233" data-mp="1u4hovavgzl8k">
        <Reveal data-id="element-234" data-mp="xe78xkybkrjz">
          <SectionHeading id="tomos" title="Qué encontrarás dentro" data-id="element-235" data-mp="xegxr57moso3" />
        </Reveal>

        <ol className="mt-5 grid gap-3 md:grid-cols-2 lg:grid-cols-3" data-id="element-236" data-mp="11e9c5yjpdt1d">
          {tomos.map((tomo, i) => <Reveal key={tomo.title} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-xl border border-white/10 border-t-4 border-t-volt bg-night p-4" data-id="element-237" data-mp="16f5c610xov1i" data-mpi={i}>
              <h3 className="flex items-start gap-2 font-display text-[0.95rem] uppercase leading-tight text-volt sm:text-base" data-id="element-238" data-mp="2mqsuizxxocc8">
                <CheckCircle2Icon size={17} className="mt-0.5 flex-shrink-0 text-success" strokeWidth={2.5} data-id="element-239" data-mp="2qmxe7eboyaow" />
                {tomo.title}
              </h3>
              <p className="mt-2 text-[0.8rem] leading-snug text-steel sm:text-sm" data-id="element-240" data-mp="2hpn59zmcixn5">
                {tomo.desc}
              </p>
              <p className="mt-1.5 text-[0.8rem] leading-snug text-steel sm:text-sm" data-id="element-241" data-mp="27p4gcqfxcqyd">
                {tomo.extraDesc}
              </p>
              <p className="mt-auto pt-3 font-script text-lg leading-tight text-volt sm:text-xl" data-id="element-242" data-mp="22xur3qyafpn0">
                {tomo.tag}
              </p>
            </Reveal>)}
        </ol>

        <Reveal delay={0.1} className="mt-6 text-center" data-id="element-243" data-mp="1tz0w250lv7bk">
          <h3 className="font-display text-lg uppercase text-white sm:text-2xl" data-id="element-244" data-mp="1oyvc7b0kup41">
            Mira todo lo que incluye
          </h3>
          <p className="mx-auto mt-2 max-w-2xl text-[0.85rem] leading-snug text-steel sm:text-base" data-id="element-245" data-mp="1jziiq7f7ajsh">
            Dentro encontrarás explicaciones, esquemas, actividades, ejercicios,
            casos y herramientas creadas para ayudarte a convertir conceptos
            eléctricos en conocimientos que puedas comprender y repasar.
          </p>
          <div className="mt-4 flex justify-center" data-id="element-246" data-mp="11dkr155k4gsn">
            <CtaButton size="lg" data-id="element-247" data-mp="15e4lg0yqx6b3">
              ¡SÍ! QUIERO APRENDER ELECTRICIDAD DESDE CERO
            </CtaButton>
          </div>
        </Reveal>
      </div>
    </section>;
}